import React from "react";

import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { trackPage } from "../../analytics";

const styles = {
  title: {
    textAlign: "center",
    paddingLeft: "5px"
  }
};
const Forbidden = props => {
  const { classes } = props;

  React.useEffect(() => {
    trackPage("forbidden");
  }, []);

  return (
    <Grid container justify="center">
      <Grid item xs={12} md={6} className={classes.title}>
        <Grid container>
          <Grid item xs={12} className={classes.title}>
            <h3>
              Please sign up through BAMS. <br />
            </h3>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(Forbidden);
